import React from 'react';
import type {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu/Menu';

import {Controller, useFormContext} from 'react-hook-form';

import {Checkbox} from '@spaced-out/ui-design-system/lib/components/Checkbox';
import {Dropdown} from '@spaced-out/ui-design-system/lib/components/Dropdown';
import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';
import {BodySmall} from '@spaced-out/ui-design-system/lib/components/Text';

import {TextInput} from '../text-input/text-input';

import type {FormInputProps} from './types';

import css from './form-input.css';


export const FormInput: React.FC<FormInputProps> = ({
  item,
  disabled = false,
}) => {
  const {
    register,
    control,
    formState: {errors},
  } = useFormContext();

  switch (item.type) {
    case 'consent':
    case 'checkbox':
      return (
        <Controller
          control={control}
          name={item.name}
          render={({field}) => {
            return (
              <div className={css.checkboxContainer}>
                <Checkbox
                  checked={field.value as boolean}
                  onChange={() => {
                    field.onChange(!field.value);
                  }}
                  error={Boolean(errors[item.name]?.message)}
                  disabled={disabled}
                >
                  {/* Note: translation already handled */}
                  {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
                  {item.label}
                </Checkbox>
                {errors[item.name]?.message ? (
                  <BodySmall color="danger">
                    {errors[item.name]?.message as string}
                  </BodySmall>
                ) : null}
              </div>
            );
          }}
        />
      );

    case 'dropdown':
      return (
        <Controller
          control={control}
          name={item.name}
          render={({field}) => (
            <Dropdown
              dropdownInputText={field.value as string}
              // Note: translation already handled
              // eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels
              label={item.label}
              menu={{
                options: item.options?.map((value) => ({
                  label: value,
                  key: value,
                })),
              }}
              onChange={(option: MenuOption) => field.onChange(option.key)}
              disabled={disabled}
            />
          )}
        />
      );

    case 'multi_line_text':
      return (
        <Textarea
          error={Boolean(errors[item.name]?.message)}
          errorText={errors[item.name]?.message as string}
          // Note: translation already handled
          // eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels
          label={item.label}
          required
          disabled={disabled}
          {...register(item.name)}
        />
      );

    default:
      return (
        <TextInput
          control={control}
          label={item.label}
          name={item.name}
          placeholder={item.placeholder}
          required={item.isRequired}
          type={item.type === 'number' ? 'number' : undefined}
          disabled={disabled}
        />
      );
  }
};
